import request from '@/utils/request'

//查询作业管理列表
export function gettaskList(query) {
	return request({
		url: '/api/vrTask/taskList',
		method: 'get',
		params: query
	})
}
//根据作业id查询课程作业试题
export function getTopicByTaskId(query) {
	return request({
		url: '/api/vrTask/getTopicByTaskId',
		method: 'get',
		params: query
	})
}
//添加作业
export function addTask(data) {
	return request({
		url: '/api/vrTask/addTask',
		method: 'post',
		data
	})
}
//编辑更新作业
export function getupdateTask(data) {
	return request({
		url: '/api/vrTask/updateTask',
		method: 'post',
		data
	})
}
//启用作业GET 
export function getusingTask(query) {
	return request({
		url: '/api/vrTask/usingTask',
		method: 'get',
		params: query
	})
}
//禁用作业GET GET
export function getdisable(query) {
	return request({
		url: '/api/vrTask/disable',
		method: 'get',
		params: query
	})
}
//根据id查询作业
export function getTaskById(query) {
	return request({
		url: '/api/vrTask/getTaskById',
		method: 'get',
		params: query
	})
}
//根据id删除作业GET /api/task/
export function getdeleteTask(query) {
	return request({
		url: '/api/vrTask/deleteTask',
		method: 'get',
		params: query
	})
}

//查看学生已完成列表
export function listUserTask(query) {
	return request({
		url: '/api/userRecord/getUserTaskList',
		method: 'get',
		params: query
	})
}
//查看学生答题详情
export function getUserTask(query) {
	return request({
		url: '/api/userRecord/getuserAnswerByRecordId',
		method: 'get',
		params: query
	})
}

//提交作业
export function taskCommit(data) {
	return request({
		url: '/api/userRecord/commit',
		method: 'post',
		data
	})
}
//根据实验id、作业id查询当前用户作答次数
export function getCommitCount(query) {
	return request({
		url: '/api/userRecord/getCommitCount',
		method: 'get',
		params: query
	})
}

//个人中心-实验作业记录查询
export function getUserTaskRecordCenter(data) {
	return request({
		url: '/api/vrTask/getUserTaskRecordCenter',
		method: 'get',
		params: data
	})
}



